import { render } from "./Yuanquzl.vue?vue&type=template&id=2802f1b3&scoped=true"
import script from "./Yuanquzl.vue?vue&type=script&lang=js"
export * from "./Yuanquzl.vue?vue&type=script&lang=js"

import "./Yuanquzl.vue?vue&type=style&index=0&id=2802f1b3&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2802f1b3"

export default script